/**
 * Route guard for the generative-audiences vertical (ACT2-492). Audiences are GA (ACT2-614), so this
 * passes for every workspace the server has not explicitly disabled.
 *
 * Reads `isAudiences` from the WorkspaceContext (server-derived, propagated via auth.me).
 * When false: redirects to the workspace home. When true: renders children.
 *
 * Intentionally NOT the localStorage dev-flag system (FeatureFlagsContext) — the same reasoning as
 * `RequireWorkflowsV2`: dev flags would expose the vertical to every dev workspace or hide it from an
 * enabled production one.
 */
import { Navigate } from 'react-router-dom';

import { useWorkspace } from '@/_shared/contexts/WorkspaceContext';

interface RequireAudiencesProps {
  children: React.ReactNode;
}

export function RequireAudiences({ children }: RequireAudiencesProps): React.ReactElement {
  const { isAudiences, wp } = useWorkspace();

  if (!isAudiences) {
    return <Navigate to={wp()} replace />;
  }

  return <>{children}</>;
}
